import { UrlUtil } from './url-util';
import { AppStoreLinksService } from './appStoreLinks.service';
import { AnalyticsData } from '../../../models/analytics-data';
import { MobileAppLinks } from '../../../models/mobile-app-links';
import { FeatureFlagsService } from './feature-flags.service';
import { FeatureFlagDictionaryEnum } from 'src/app/shared/enums';

export class UrlCelebrityService {
	private util: UrlUtil;
	private appStoreService: AppStoreLinksService;
	constructor(private urls: any, private wul: string, private featureFlagsService: FeatureFlagsService) {
		this.util = new UrlUtil();
		this.appStoreService = new AppStoreLinksService();
	}

	aboutUs(src?: string) {
		const urlMap: { [origin: string]: string } = {
			es: '/about-us/company-profile',
			br: '/about-us/company-profile',
			espanol: '/about-us/company-profile',
			com: '/about-us/company-profile'
		};

		return this.util.getMappedUrl(urlMap, 'celebritycruises.com/about-us/company-profile', src);
	}

	contactUs(src?: string) {
		const urlMap: { [origin: string]: string } = {
			es: '/company/customer-support/contact-us',
			br: '/company/customer-support/contact-us',
			espanol: '/company/customer-support/contact-us',
			com: '/company/customer-support/contact-us'
		};

		return this.util.getMappedUrl(urlMap, 'celebritycruises.com/company/customer-support/contact-us', src);
	}

	privacyPolicy(src?: string) {
		// Celebrity doesn't have this link
		return '/privacy-policy';
	}

	legal(src?: string) {
		const urlMap: { [origin: string]: string } = {
			es: '/legal-information',
			br: '/legal-information',
			espanol: '/legal-information',
			com: '/legal-information'
		};

		return this.util.getMappedUrl(urlMap, 'celebritycruises.com/legal-information', src);
	}

	siteMap(src?: string) {
		const urlMap: { [origin: string]: string } = {
			es: '/company/customer-support/sitemap',
			br: '/company/customer-support/sitemap',
			espanol: '/company/customer-support/sitemap',
			com: '/company/customer-support/sitemap'
		};

		return this.util.getMappedUrl(urlMap, 'celebritycruises.com/company/customer-support/sitemap', src);
	}

	faq(src?: string) {
		const urlMap: { [origin: string]: string } = {
			es: '/company/customer-support/help-and-faqs/pre-cruise/online-check-in',
			br: '/company/customer-support/help-and-faqs/pre-cruise/online-check-in',
			espanol: '/company/customer-support/help-and-faqs/pre-cruise/online-check-in',
			com: '/company/customer-support/help-and-faqs/pre-cruise/online-check-in'
		};

		return this.util.getMappedUrl(
			urlMap,
			'celebritycruises.com/company/customer-support/help-and-faqs/pre-cruise/online-check-in',
			src
		);
	}

	private isNewGAEnabled(): boolean {
		const flags = this.featureFlagsService.snapshot;
		return flags?.[FeatureFlagDictionaryEnum.NEW_GA_DASHBOARD_ENABLED] || false;
	}

	curtesyHolds(src?: string) {
		return this.isNewGAEnabled() ? '/myaccount/courtesy-holds' : '/account/courtesy-holds';
	}

	royalGifts(src?: string) {
		return null; // null means do not show on UI
	}

	upcomingCruises(src?: string) {
		return this.isNewGAEnabled() ? '/myaccount/my-trips?tab=upcoming' : '/account/upcoming-cruises';
	}

	pastCruises(src?: string) {
		return this.isNewGAEnabled() ? '/myaccount/my-trips?tab=past' : '/account/past-cruises';
	}

	cubaAffidavitLink() {
		return '/cruise-destinations/a-quick-guide-to-cruising-to-cuba';
	}

	riskAcknowledgementContactUs() {
		return `https://www.healthyatsea.com/healthycontacts?wul=${this.wul}`;
	}

	mobileAppLinks(payload: AnalyticsData): MobileAppLinks {
		return this.appStoreService.getStoreAppLinks(this.urls, payload);
	}
}
